module.exports = __webpack_public_path__ + "static/media/IconosGas-07.5838d76e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gas/IconosGas-07.svg
// module id = 751
// module chunks = 0